import gql from 'graphql-tag';
import { storeBasicFields } from './GetStore';
import { PromotionBasicFields } from './fragments/Promotion';

const key = `GetStorePromotionsByPeriod`;
const query = gql`
${PromotionBasicFields}
query ${key} ($storeId: ID!, $promotionsLimit: Int = 100, $periodId: ID!) {
  getStore(
    id: $storeId
  ){
    ${storeBasicFields}
    promotions(limit: $promotionsLimit, filter: {promotionPeriodId: {eq: $periodId}}) {
      nextToken
      items{
        ...PromotionBasicFields
      }
    }
  }
}
`;

export const GET_STORE_PROMOTIONS_BY_PERIOD = { key, query };
